import React from 'react';
import LatestBlog from './LatestBlog';
import Newsletter from './NewsLetter';
import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';




const GetInTouch = () => {

  const [isSubmitted, setIsSubmitted] = useState(false);


  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitted(true); // disable the button immediately

    emailjs
      .sendForm('service_yalh5wy', 'template_6fiq0l4', form.current, {
        publicKey: '_IokqDxhynHK8phwD',
      })
      .then(
        () => {
          alert('Submitted successfully!');
          form.current.reset();         // Optional: clear form fields
          setIsSubmitted(true);         // Keep button disabled
        },
        (error) => {
          console.log('FAILED...', error.text);
          setIsSubmitted(false);        // Re-enable button on failure
        }
      );
  };

  return (
    <>


      {/* Map Background with Form Overlay */}
      <div style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
        {/* Google Map Iframe as Background */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d14016.42562878574!2d77.222909!3d28.5665673!3m2!1i1024!2i768!4f13.1!2m1!1sN%2018%20Lower%20Ground%20Floor%20South%20Extension%201%20Block%20H%20New%20Delhi%20Delhi%20110049!5e0!3m2!1sen!2sin!4v1768566091374!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0, position: 'absolute', top: 0, left: 0, zIndex: 1 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>



        {/* Form Container with Semi-transparent Background */}
        <div id='GetInTouchForm' className="container h-100 d-flex align-items-center justify-content-center">
          <div className="col-md-6 p-4 rounded shadow bg-white" style={{ zIndex: 2, position: 'relative', opacity: 0.95 }}>
            <h3 className="fw-bold mb-4 text-center">Get in Touch</h3>
            <form ref={form} onSubmit={sendEmail}>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name*"
                  name="name"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email*"
                  name="email"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="tel"
                  name="phone"
                  className="form-control"
                  placeholder="Phone*"
                  required
                />
              </div>
              <div className="mb-4">
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Comment*"
                  name="message"
                  required
                ></textarea>
              </div>
              <div className="text-center">
                <button
                  type="submit"
                  className="btn btn-info text-white px-4 fw-semibold"
                  disabled={isSubmitted}
                >
                  {isSubmitted ? "Submitted" : "Send Message"}
                </button>

              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default GetInTouch;
